import { Injectable } from '@angular/core';
import { DeviceSettingsFeatureToggle } from 'src/app/enums/feature-toggle.enum';
import { ISectionPresenter } from 'src/app/presenters/models/section-presenter';
import { FeatureToggleService } from 'src/app/services/feature-toggle/feature-toggle.service';

@Injectable({
	providedIn: 'root',
})
export class DisplaySection implements ISectionPresenter {
	constructor(private featureToggleService: FeatureToggleService) {}

	isVisible(): Promise<boolean> {
		const isFeatureToggleEnabled = this.featureToggleService.isDeviceSettingsFeatureAvailable(
			DeviceSettingsFeatureToggle.DisplayAndCameraDisplay
		);

		return Promise.resolve(isFeatureToggleEnabled);
	}
}
